<template>
  <div class="app">
    <nav class="menu">
      <div class="content">
        <img src="../assets/logo.png"/>
        <span class="name">爱德主机实操模拟</span>
        <div class="right-menu">
          <a href="/" class="selected">网站首页</a>
          <a href="/contact">联系我们</a>
          <a>用户协议</a>
        </div>
      </div>
    </nav>
    <div class="container">
      <div class="main-wrapper index">
        <div class="main index">
          <div class="index-content">
            <div class="title">爱德主机实操模拟</div>
            <div class="sub-title">
              <span>爱德主机实操模拟专为消防设施操作员线下实操考试打造！专注爱德全鉴定点机型练习，3D 实操模拟，高度还原真实操作场景。更有专业老师录制的线下实操教学，帮助快速掌握要点。</span>
              <span>爱德主机实操模拟是本公司完全自主研发、行业领先的消防设施操作学习平台。平台实现了设施实操、交互动画、仿真考核三大功能，爱德主机实操模拟学练一体、核心模拟实验全覆盖、为您提供科学的学习方法。无论你是零基础还是急需提升，都能轻松应对线下实操考核，开启高效备考之旅。</span>
              <!-- <span>爱德主机实操模拟考试必备，精选题库、名师解析，助您高效提分、轻松通关！ </span> -->
            </div>
          </div>
          <div class="video"><img style="width: 490px;" src="../assets/video.png"/></div>
        </div>
        <!-- <div class="app">
          <div class="ddd">
            <img src="../assets/pingguo.png" class="icon"/><span>苹果手机扫码下载</span>
            <div class="qrcode">
              <img src="../assets/ios-download.png"/>
            </div>
          </div>
          <div class="ddd">
            <img src="../assets/android.png" class="icon"/><span>安卓手机扫码下载</span>
            <div class="qrcode">
              <img src="../assets/android-download.png"/>
            </div>
        </div>
      </div> -->
      </div>
      <div class="main-wrapper app">
        <div class="ddd">
            <div class="t"><img src="../assets/ios.svg" class="icon"/><span>苹果手机</span></div>
            <div class="qrcode">
              <img src="../assets/ios-download.png"/>
            </div>
            <span>苹果手机扫码下载</span>
          </div>
          <div class="ddd">
            <div class="t"><img src="../assets/android.svg" class="icon"/><span>安卓手机</span></div>
            <div class="qrcode">
              <img src="../assets/android-download.png"/>
            </div>
            <span>安卓手机扫码下载</span>
        </div>
      </div>
      <div class="main-wrapper demo">
        <div class="main">
          <h3>APP页面展示</h3>
          <div class="lists">
            <div class="item">
              <img src="../assets/1.png"/>
              <!-- <span>练习模式</span> -->
            </div>
            <div class="item">
              <img src="../assets/2.png"/>
              <!-- <span>会员中心</span> -->
            </div>
            <div class="item">
              <img src="../assets/3.png"/>
              <!-- <span>答题报告</span> -->
            </div>
            <div class="item">
              <img src="../assets/4.png"/>
              <!-- <span>上传题库</span> -->
            </div>
            <div class="item">
              <img src="../assets/5.png"/>
              <!-- <span>个人中心</span> -->
            </div>
          </div>
        </div>
      </div>
      <div class="main-wrapper about">
        <div class="main">
          <h3>公司介绍</h3>
          <div class="profile">
            <p>上海爻塔科技有限公司 (ShanghaiYaotaTechnology Co.,Ltd.) 成立于 2019 年，公司坐落于上海市崇明区，主要从事科技研究和技术服务业，特别是专注于软件开发、Al 交互、3D 仿真等科技类业务。</p>
            <p>上海爻塔科技有限公司致力于为客户提供从策划、创意、设计到制作的一站式程序开发服务，已成功服务了数百家 B 端客户，赢得了良好的市场口碑。此外，公司开发的多款软件产品，包括但不限于消防实操模拟软件、职教 AI、大千排盘 APP、求灵签、电网刷题等，广受用户好评。</p>
            <p>上海爻塔科技有限公司遵从“互联网+上海爻塔科技有限公司遵从 “互联网 +” 的概念思维，致力于呈现前沿的软件研发成果，帮助客户实现品牌价值的最大化。公司秉承 “创新科技，提升效率” 的宗旨，站在用户的角度，提供个性化的创意解决方案。未来，上海爻塔科技有限公司将继续深耕科技推广和应用服务业，不断创新，为客户提供更加优质、高效的服务，推动公司在行业内的持续发展和壮大。</p>
          </div>
          <img src="../assets/profile.png"/>
        </div>
      </div>
      <div class="main-wrapper product">
        <div class="main">
          <h3>公司产品</h3>
          <div class="lists">
            <div class="item">
              <img src="../assets/p1.png"/>
            </div>
            <div class="item">
              <img src="../assets/p2.png"/>
            </div>
            <div class="item">
              <img src="../assets/p3.png"/>
            </div>
            <div class="item">
              <img src="../assets/p4.png"/>
            </div>
            <div class="item">
              <img src="../assets/p5.png"/>
            </div>
            <div class="item">
              <img src="../assets/p6.png"/>
            </div>
            <div class="item">
              <img src="../assets/p7.png"/>
            </div>
            <div class="item">
              <img src="../assets/p8.png"/>
            </div>
          </div>
        </div>
      </div>
      <div class="main-wrapper footer">
        <div class="main" style="font-weight:normal">
          Copyright &COPY; 2024 爱德主机实操模拟  <a href="https://beian.miit.gov.cn" style="color:#333;text-decoration: none;">沪ICP备19026759号-30</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import yaml from 'js-yaml'
import axios from 'axios'
export default {
  name: 'app',
  data() {
    return {
      showios: false,
      showand: false,
      download: '',
      config: '',
      text: '点击下载Windows客户端 (64位)',
      visible: false,
      cvisible: false
    };
  },
  methods: {
    showcode(key) {
      if (key === 'ios') {
        this.showios = true
      } else {
        this.showand = true
      }
    },
    hidecode(key) {
      if (key === 'ios') {
        this.showios = false
      }else{
        this.showand = false
      }
    },
    downloadClient(){
      location.href = this.download
    }
  },
  mounted() {
    // this.getPosType()
  }
};
</script>

<style lang="less" scoped>
@font-face {
	  font-family: 'Truth';
	  src: url('../assets/fonts/truth.woff') format('woff'), url('../assets/fonts/truth.otf') format('otf'), url('../assets/fonts/truth.ttf') format('opentype');
	  font-style: normal;
	  font-weight: normal;
	}
html,
body {
  margin: 0;
  padding: 0;
  /* height: 100%; */
  width: 100%;
  /* overflow: hidden; */
  font-family: "microsoft yahei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}
.app {
  /* height: 100%; */
  width: 100%;
}
p {
  /* margin: 0; */
  /* text-align: center; */
  /* width: 800px; */
  margin: 0 auto;
}
h1,h3,h4,h2,h5{
  padding: 0;
  margin: 0;
}
h3{
  font-size: 32px;
  margin-bottom: 20px;
  // font-family: 'Truth';
  font-weight: 500;
}
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
}
.container{
  width: 100%;
}
.menu{
  // position: absolute;
  // left: 0;
  // right: 0;
  // top: 0;
  background: rgba(255, 255, 255, 1);
  .content{
    width: 1200px;
    margin: 0 auto;
    color: #fff;
    display: flex;
    align-items: center;
    padding: 15px 0;
    font-size: 24px;
    // justify-content: space-between;
    img{
      width: 48px;
      height: 48px;
      margin-right: 10px ;
      border-radius: 10px;
      border: 1px solid #F5F5F5;

    }
    .name{
      color: #333;
      font-size: 26px;
      font-weight: 700;
      font-family: 'Truth';
    }
  }
  .right-menu{
    font-size: 16px;
    color: #333;
    cursor: pointer;
    // font-weight: 500;
    margin-left: auto;
    a{
      width: 140px;
      display: inline-block;
      text-align: center;
      text-decoration: none;
      color: #333;
      &.selected{
        color: #0E8881;
        position: relative;
        &::before{
          content: '';
          position: absolute;
          width: 30px;
          height: 2px;
          background: #0E8881;
          left: 50%;
          transform: translateX(-50%);
          bottom: -5px;
          border-radius: 4px;
        }
      }
    }
  }
  .free{
    margin-right: 30px;
    color: #0E8881;
    position: relative;
    &::before{
      content: '免费';
      font-size: 6px;
      position: absolute;
      right: -20px;
      top: -15px;
      background-color: #CE5653;
      color: #fff;
      padding: 0 5px;
      border-radius: 10px;
    }
  }
}

.main{
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  /* display: inline-block; */
  &.index{
    // margin-top: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    justify-content: space-between;
    margin: 30px auto;
    h1{
      font-size: 48px;
    }
    h4{
      font-size: 36px;
      font-weight: 400;
      margin-top: 20px;
      margin-bottom: 50px;
    }
    .video{
      width: 490px;
      height: 388px;
      min-width: 490px;
      img{
        width: 490px;
        min-width: 490px;
        height: 388px;
      }
    }
    
  }
  &.resume{
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.index-phone {
  display: inline-block;
  img{
    width: 264px;
    margin-right: 150px;
  }
}
.index-content{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .title{
    font-size: 58px;
    font-weight: 600;
    font-family: 'Truth';
    color: #333;
    display: flex;
    align-items: flex-end;
  }
  .sub-title{
    margin-top: 20px;
    font-size: 18px;
    color: #999;
    display: flex;
    flex-direction: column;
    // align-items: flex-start;
    // justify-content: space-between;
    span{
      position: relative;
      // padding-left: 20px;
      line-height: 30px;
      text-align: left;

    }
  }
}
.main-wrapper{
  width: 100%;
  display: inline-block;
  &.index{
    height: 500px;
    // background: url('../assets/bgggg.png');
    // background-size: 100% auto;
    background: linear-gradient(96deg, #FFF 3.15%, #bdd2e8 100%);
    
  }
  &.app{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 1200px;
      margin: 60px auto 60px auto;
      .ddd{
        display: flex;
        align-items: center;
        flex-direction: column;
        // width: 240px;
        // background: #0E8881;
        // border-radius: 50px;
        justify-content: center;
        width: 576px;
        height: 361px;
        // height: 44px;
        cursor: pointer;
        position: relative;
        border-radius: 8px;
        color: #333;
        background: #FFF;
        box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.10);
        .t{
          display: flex;
          align-items: center;
          font-size: 24px;
          font-weight: 500;
        }
        .icon{
          height: 40px;
          margin-right: 5px;
        }
        .qrcode{
          // position: absolute;
          // left: 50%;
          // transform: translateX(-50%);
          // top: 70px;
          box-sizing: border-box;
          border: 5px solid #fff;
          background-color: #fff;
          border-radius: 5px;
          &::before{
            width: 0;
            height: 0;
            border-bottom: 10px solid #fff;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            font-size: 0;
            line-height: 0;
            top: -14px;
            left: 50%;
            transform: translateX(-50%);
            display: inline-block;
            content: "";
            position: absolute;
            z-index: 9999;
          }
          img{
            width: 180px;
            border: 1px solid #999;
          }
        }
      }
    }
  &.about{
    background: #fff;
    text-align: center;
    color: #333;
    padding: 60px 0;
    .profile{
      margin: 40px 0;
      p{
        text-align: left;
        line-height: 1.5;
        font-size: 18px;
        color: #666;
      }
    }
  }
  &.product {
    /* width: 100%; */
    position: relative;
    padding: 60px 0;
    text-align: center;
    color: #333;
    background: #FAFAFA;
    .lists{
      display: grid;
      grid-template-columns: 180px 180px 180px 180px;
      margin-top: 50px;
      // gap: 160px 50px;
      grid-row-gap: 50px;
      grid-column-gap: 160px;
      .item{
        // margin-bottom: 40px;
        // display: flex;
      }
      img{
        width:180px;
        height: auto;
        // border-radius: 28px;
      }
    }
    img{
      width: 180px;
    }
  }
  &.many{
    text-align: center;
    color: #333;
    padding: 50px 0;
    img{
      width: 1000px;
      margin-top: 80px;
    }
  }
  &.demo{
    background: #FAFAFA;
    padding: 60px 0;
    h3{
      color: #333;
    }
    .lists{
      display: flex;
      align-items: center;
      // flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 50px;
      .item{
        margin-bottom: 40px;
      }
      img{
        width:200px;
        height: auto;
        border-radius: 28px;
      }
    }
  }
  &.footer{
    background: #fff;
    padding: 32px 0;
    text-align: center;
    color: #333;
    border-top: 1px solid #EFEFEF;
  }
}
.popup{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.6);
  .p-body{
    position: absolute;
    width: 600px;
    height: 500px;
    background: #fff;
    color: #333;
    box-sizing: border-box;
    padding: 20px;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .p-title{
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 20px;
    span{
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 30px;
      font-weight: 100;
      cursor: pointer;
      padding: 0 5px;
    }
  }
  p{
    line-height: 2;
    &.q{
      font-weight: 500;
      margin: 10px 0;
    }
    &.a{
      color: #666;

      font-size: 14px;
    }
  }
}
.items{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 50px;
  .item{
    width: 254px;
    text-align: center;
    display: flex;
    height: 182px;
    overflow: hidden;
    margin-bottom: 60px;
    img{
      width: 100%;
      height: 182px;
    }
    &:last-child{
      width: 569px;
    }
  }
}
.mutil{
  // margin-top: 80px;
  padding: 40px 0;
  // background: linear-gradient(90deg, rgba(29, 97, 232,0.3), rgba(211, 230, 252,0.3));
  color: #333;
  // background: url('../assets/mutilbg.png') no-repeat;
  // background-size: 100% auto;
}
.hezuo{
  color: #333;
  margin-top: 80px;
  margin-bottom: 80px;
  span{
    color: #CE5653;
  }
  .lists{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;
    margin-top: 40px;
    div{
      width: 240px;
      height: 240px;
      background: #fcfcfc;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #f4f4f4;
      border-bottom: 1px solid #f4f4f4;
      box-sizing: border-box;
      &:hover{
        background: rgba(55, 111, 246, 0.3);
      }
    }
    img{
      width: 120px;
      height: 120px;
      border-radius: 120px;
    }
  }
}
.color{
  color:#CE5653 ;
}
@media screen and (max-width: 768px) {
  .menu{
    .content{
      padding: 15px 20px;
      width: 100%;
      box-sizing: border-box;
    }
    .right-menu{
      display: none;
    }
  }
  .index-content{
    .title{
      font-size: 30px;
      // flex-direction: column;
      align-items: flex-end;
      div{      
        span:first-child{
          color: #CE5653;
          font-family: 'Truth';
          font-size: 30px;
        }
      }
      .subfix{
        // margin-left: 0;
        font-size: 17px;
        // margin-top: 10px;
      }
    }
  }
  .sub-title{
    .pc,.phone{
      display: none;
    }
    span::before{
      top:8px !important;
      margin-top: 0 !important;
    }
  }
  .h5{
      display: inline-block !important;
      margin-bottom: 5px;
    }
  .buttons{
    display: none;
  }
  .main.index{
    flex-direction: column;
    width: 100%;
    margin-top: 100px;
    box-sizing: border-box;
    padding: 0 20px;
    justify-content: center;
    .video {
      width: 100%;
      height: auto;
      margin-top: 40px;
      img{
        width: 100%;
        height: auto;
      }
    }
  }
  .main-wrapper.index{
    background-repeat: no-repeat;
    background-size: auto 100%;
    height: 520px;
    .app{
      display: none;
    }
  }
  .main-wrapper.jobs{
    display: none;
  }
  .main{
    width: 100%;
  }
  .hezuo{
    margin-top: 40px;
    margin-bottom: 40px;
    p{
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
  .hezuo .lists{
    width:100%;
    justify-content: center;
    div{
      width: 50%;
    }
  }
  .main-wrapper.demo {
    .lists{
      box-sizing: border-box;
      padding: 0 20px;
      .item{
        margin-bottom: 20px;
      }
      img{
        width:100%;
        height: auto;
      }
    }
  }
  .main-wrapper.footer{
    font-size: 14px;
  }
  .mutil{
    background-size: auto 100%;
    p{
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
  h3{
    font-size: 28px;
  }
  p,span{
    text-align: left;
  }
}
</style>
